import type { IntegrationDefinition } from "./IntegrationsCatalogShared";
import { textField, tokenField } from "./IntegrationsCatalogShared";

export const catalogPart3: IntegrationDefinition[] = [
  {
    kind: "netvisor",
    label: "Netvisor",
    group: "Finance & payments",
    description:
      "Connect Finnish accounting, e-invoicing, payroll, and working-time data.",
    setup:
      "Enable Netvisor API access through your accounting provider and enter the integration credentials.",
    capabilities: [
      { key: "accounting", label: "Accounting" },
      { key: "e_invoicing", label: "E-invoices" },
      { key: "payroll", label: "Payroll" },
    ],
    fields: [
      textField(
        "sender",
        "Netvisor sender",
        "The sender identifier issued by Netvisor.",
        { required: true, placeholder: "Sender" },
      ),
      textField(
        "customerId",
        "Netvisor customer ID",
        "The customer ID issued by Netvisor.",
        { required: true, placeholder: "Customer ID" },
      ),
      textField(
        "customerKey",
        "Netvisor customer key",
        "The customer secret used for HMAC signing.",
        {
          type: "password",
          secret: true,
          required: true,
          placeholder: "Paste customer key",
        },
      ),
      textField(
        "partnerId",
        "Netvisor partner ID",
        "The partner identifier issued for this integration.",
        { required: true, placeholder: "Partner ID" },
      ),
      textField(
        "partnerKey",
        "Netvisor partner key",
        "The partner secret used for HMAC signing.",
        {
          type: "password",
          secret: true,
          required: true,
          placeholder: "Paste partner key",
        },
      ),
      textField(
        "organisationId",
        "Netvisor organisation ID",
        "The organisation identifier used in signed requests.",
        { required: true, placeholder: "Organisation ID" },
      ),
      textField(
        "baseUrl",
        "Netvisor API URL",
        "The Netvisor integration endpoint.",
        {
          type: "url",
          required: true,
          defaultValue: "https://integration.netvisor.fi",
        },
      ),
      textField(
        "accountId",
        "Customer or company ID",
        "Optional identifier for the connected Netvisor company.",
        { placeholder: "Company ID" },
      ),
    ],
  },
  {
    kind: "thefork",
    label: "TheFork",
    group: "Restaurant operations",
    description:
      "Read restaurant availability and reservations from TheFork Manager.",
    setup:
      "Use a TheFork partner API credential and enter the restaurant UUID.",
    capabilities: [
      { key: "reservations", label: "Reservations" },
      { key: "reviews", label: "Guest context" },
    ],
    fields: [
      tokenField(
        "TheFork partner token",
        "The partner credential for TheFork’s B2B API.",
      ),
      textField(
        "restaurantId",
        "Restaurant UUID",
        "The restaurant identifier used by TheFork.",
        { required: true, placeholder: "Restaurant UUID" },
      ),
      textField(
        "baseUrl",
        "TheFork API URL",
        "The TheFork partner API base URL.",
        { type: "url", required: true, defaultValue: "https://api.thefork.io" },
      ),
    ],
  },
  {
    kind: "zenchef",
    label: "Zenchef",
    group: "Restaurant operations",
    description:
      "Connect reservations, guest profiles, table availability, and reviews.",
    setup:
      "Ask Zenchef for API access. A Grow subscription or partner agreement may be required.",
    capabilities: [
      { key: "reservations", label: "Reservations" },
      { key: "reviews", label: "Reviews" },
    ],
    fields: [
      tokenField(
        "Zenchef API token",
        "The token provided by Zenchef for the restaurant.",
      ),
      textField(
        "baseUrl",
        "Zenchef API URL",
        "The API base URL supplied by Zenchef.",
        { type: "url", required: true, placeholder: "https://…" },
      ),
      textField(
        "restaurantId",
        "Restaurant ID",
        "The Zenchef restaurant identifier.",
        { required: true, placeholder: "Restaurant ID" },
      ),
    ],
  },
  {
    kind: "wolt_drive",
    label: "Wolt Drive",
    group: "Restaurant operations",
    description:
      "Quote, create, and track last-mile deliveries from your own ordering flow.",
    setup:
      "Request Wolt Drive development credentials and enter the merchant ID.",
    capabilities: [{ key: "delivery", label: "Delivery tracking" }],
    fields: [
      tokenField(
        "Wolt Drive merchant key",
        "The bearer token issued for Wolt Drive.",
      ),
      textField(
        "merchantId",
        "Merchant ID",
        "The Wolt Drive merchant identifier.",
        { required: true, placeholder: "Merchant ID" },
      ),
      textField(
        "baseUrl",
        "Wolt Drive API URL",
        "Only change this for the development environment.",
        { type: "url", defaultValue: "https://daas-public-api.wolt.com" },
      ),
    ],
  },
];
